import React from 'react';
import { IConfig, ISelect, IInput, IUpload, ISearch, ICustom } from './interface';
import ABSInput from '../ABSInput';
import ABSSelect from '../ABSSelect';
import ABSUpload from '../ABSUpload';
import ABSDatePicker from '../ABSDatePicker';
import ABSFieldCustom from '../ABSField/Custom';
import ABSSearch from '../ABSSearch';
import { defaultResult, isPass } from '../../utils/Validator';
import commonUtils from '../../utils/commonUtils';

interface IABSFlexibleFormProps {
  config: IConfig[];
  labelWidth?: number;
  contentWidth?: number | string;
  // 是否横向显示（区分行元素、块元素）
  isWrap?: boolean;
}

class ABSFlexibleForm extends React.Component<IABSFlexibleFormProps, any> {
  static defaultProps = {
    labelWidth: 64,
    isWrap: false
  };

  elementsObj: any = {};
  valuesObj: any = {};

  getValue = () => {
    this.valuesObj = {};
    // tslint:disable-next-line:forin
    for (let item in this.elementsObj) {
      if (this.elementsObj[item]) {
        this.valuesObj[item] = this.elementsObj[item].getValue();
      }
    }
    return this.valuesObj;
  };

  reset = () => {
    // tslint:disable-next-line:forin
    for (let item in this.elementsObj) {
      if (this.elementsObj[item]) {
        this.elementsObj[item].reset();
      }
    }
  };

  validatorValue = () => {
    let result = 1;
    // tslint:disable-next-line:forin
    for (let item in this.elementsObj) {
      if (this.elementsObj[item]) {
        result *= Number(isPass(this.elementsObj[item]));
      }
    }
    return result;
  };

  render() {
    this.elementsObj = {};
    const { config } = this.props;
    if (!Array.isArray(config)) {
      return null;
    }
    return <>{this.renderFlexibleContent()}</>;
  }

  renderFlexibleContent() {
    const { config, labelWidth: lw, isWrap: wrap, contentWidth: cw } = this.props;

    const { length } = config;

    let component;
    let components: any[] = [];

    return config.map((item, index) => {
      const {
        name,
        placeholder,
        defaultValue,
        disabled,
        rules,
        multiple,
        required,
        title,
        titleClassName,
        labelWidth = lw,
        contentWidth = cw,
        removePaddingLeft,
        removeMarginBottom,
        isVertical,
        contentClassName,
        result = defaultResult,
        desc,
        onChange,
        isWrap = wrap,
        select = {},
        input = {},
        date = {},
        search,
        upload = {},
        custom = {}
      } = item;

      const titleProps = {
        required,
        title,
        titleClassName,
        labelWidth,
        contentWidth,
        removePaddingLeft,
        removeMarginBottom,
        isVertical,
        contentClassName,
        result,
        desc,
        isWrap
      };

      switch (item.type) {
        case 'input':
          component = (
            <ABSInput
              ref={view => {
                this.elementsObj[name] = view;
              }}
              defaultValue={defaultValue}
              placeholder={placeholder}
              rules={rules}
              onChange={onChange}
              {...input}
              {...titleProps}
            />
          );
          break;

        case 'select':
          const { options } = select;
          component = (
            <ABSSelect
              ref={view => {
                this.elementsObj[name] = view;
              }}
              selectOptions={options}
              defaultValue={defaultValue}
              placeholder={placeholder}
              rules={rules}
              onChange={onChange}
              {...select}
              {...titleProps}
            />
          );
          break;

        case 'date':
          component = (
            <ABSDatePicker
              ref={view => {
                this.elementsObj[name] = view;
              }}
              defaultValue={defaultValue}
              placeholder={placeholder}
              onChange={onChange}
              {...date}
              {...titleProps}
            />
          );
          break;

        case 'search':
          component = (
            <ABSSearch
              ref={view => {
                this.elementsObj[name] = view ? view.getWrappedInstance() : view;
              }}
              defaultValue={defaultValue}
              disabled={disabled}
              handleChange={onChange}
              {...search}
              {...titleProps}
            />
          );
          break;

        case 'upload':
          component = (
            <ABSUpload
              ref={view => {
                this.elementsObj[name] = view;
              }}
              fileList={defaultValue}
              multiple={multiple}
              {...upload}
              {...titleProps}
            />
          );
          break;
        case 'br':
          component = <div />;
          break;
        case 'custom':
          component = <ABSFieldCustom {...custom} {...titleProps} />;
          break;
        default:
          component = null;
          break;
      }

      // 空组件
      if (!component) {
        return null;
      }

      // 搜集横向显示的组件
      if (isWrap) {
        components.push(component, <div key={String(Math.random() * 100)} style={{ width: 10, height: 0 }} />);
        if (length === index + 1) {
          return (
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }} key={index.toString()}>
              {components}
            </div>
          );
        }
        return null;
      }

      // 竖向显示的组件
      if (commonUtils.isEmpty(components)) {
        return component;
      }

      // 显示所有横向的组件
      const swap = components.slice();
      components = [];
      return (
        <React.Fragment key={index.toString()}>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>{swap}</div>
          {component}
        </React.Fragment>
      );
    });
  }
}

export { IConfig, ISelect, IInput, IUpload, ISearch, ICustom };

export { IABSFlexibleFormProps };

export default ABSFlexibleForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSFlexibleForm/index.tsx